export default "__VITE_PUBLIC_ASSET__c86f117f__"